import React from 'react';
import { ArrowRight, Shield, Loader2 } from 'lucide-react';

interface PaywallCTAProps {
  onUnlock: () => void;
  isLoading?: boolean;
}

export function PaywallCTA({ onUnlock, isLoading }: PaywallCTAProps) {
  return (
    <div className="space-y-4">
      <button
        onClick={onUnlock}
        disabled={isLoading}
        className="w-full bg-gray-900 hover:bg-gray-800 text-white font-semibold py-4 px-6 rounded-xl transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {isLoading ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span>Redirecting to checkout...</span>
          </>
        ) : (
          <>
            <span>Unlock My Full Blueprint</span>
            <ArrowRight className="w-4 h-4 ml-1" />
          </>
        )}
      </button>

      <div className="flex items-start gap-3 p-4 bg-emerald-50 rounded-lg border border-emerald-100">
        <Shield className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-emerald-800">
          <span className="font-medium">100% Money-Back Guarantee:</span>{' '}
          If you don't feel 100% confident in your software decisions within 7 days, we'll refund every penny. No questions asked.
        </p>
      </div>
    </div>
  );
}
